import PartiTable from 'components/Shared/MuiTable/PartiTable'
import React, { useMemo, useState } from 'react'
import { getAmbassadorColumnsDef } from './columns'
import { TableViewType } from 'components/Shared/MuiTable'
import { getAmbassadorRowsDef } from './rows'
import { EmptyState } from './EmptyState'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import {
    selectAmbassadorBrands,
    selectAmbassadorFavorited,
    selectAmbassadorList,
    updateAmbassadorFavorite,
    UpdateAmbassadorFavoritePayload,
} from 'state/ambassadors'
import { PLATFORM_CONTENT_TYPE_ENUM } from 'services/api/constants'
import { selectRequestsAreLoading } from 'state'
import { STATE_KEYS } from 'state/requests'

interface AmbassadorTableProps {
    tableHeight: string
    contentType: PLATFORM_CONTENT_TYPE_ENUM | null
}

const AmbassadorTable = ({ tableHeight, contentType }: AmbassadorTableProps) => {
    const brandsList = useSelector(selectAmbassadorBrands)
    const [expandEngagement, setExpandEngagement] = useState(false)
    const dispatch = useDispatch()
    const ambassadorData = useSelector(selectAmbassadorList)
    const isAmbassadorLoading = useSelector(selectRequestsAreLoading([STATE_KEYS.AmbassadorList]))
    const ambassadorFavoritesMap = useSelector(selectAmbassadorFavorited)

    const handleClickFavorite = (payload: UpdateAmbassadorFavoritePayload) => {
        dispatch(updateAmbassadorFavorite(payload))
    }

    const columns = useMemo(() => {
        return getAmbassadorColumnsDef(contentType, expandEngagement, setExpandEngagement, handleClickFavorite)
    }, [contentType, expandEngagement])

    const rows = contentType ? getAmbassadorRowsDef(ambassadorData, ambassadorFavoritesMap) : []

    return (
        <AmbassadorTableWrapper>
            <PartiTable
                columns={columns}
                viewType={TableViewType.AMBASSADOR}
                rows={rows}
                isLoading={isAmbassadorLoading}
                tableHeight={tableHeight}
                rowHeight={88}
                getRowHeight={() => 'auto'}
                showSearchBar
                showFilter={!!rows.length}
                showSort={!!rows.length}
                hideToolbar={false}
                showMoreAction
                enableExport={false}
                customEmptyState={<EmptyState brandList={brandsList} contentType={contentType} />}
            />
        </AmbassadorTableWrapper>
    )
}

export default AmbassadorTable

const AmbassadorTableWrapper = styled.div`
    .MuiDataGrid-columnHeaders {
        color: ${({ theme }) => theme.colors.text.primary};
        background: ${({ theme }) => theme.colors.background.primary};
    }

    .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeaderCheckbox) .MuiDataGrid-columnHeaderTitleContainer {
        margin-right: 0;
    }

    .MuiDataGrid-columnHeader .MuiIconButton-root svg {
        color: ${({ theme }) => theme.colors.text.secondary};
    }

    .MuiDataGrid-columnHeaders .MuiDataGrid-columnHeader {
        outline: none;
        .MuiDataGrid-menuIcon .MuiButtonBase-root svg path {
            fill: ${({ theme }) => theme.colors.text.secondary};
            stroke: ${({ theme }) => theme.colors.text.secondary};
            stroke-width: 2;
        }
    }

    .engagement-header .MuiDataGrid-menuIcon {
        position: absolute;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
    }

    .MuiDataGrid-cell {
        padding: 8px 12px;
    }

    .engagement-detail-metrics {
        background: ${({ theme }) => theme.colors.surface.infoPastel};
        height: 56px;
    }
`
